




















































































import { Component, Vue } from "vue-property-decorator";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { domain, Company, User, UserAuditRecord, VueRoot } from "@/domain";
import DatePicker from "@/components/DatePicker.vue";

@Component({
  components: { DatePicker }
})
export default class UserAuditDialog extends Vue {
  isLoading = false;
  dialog = false;
  filters = {
    uid: "",
    limit: 1000,
    from: "",
    to: ""
  };
  pagination = {
    sortBy: "signInTimeUTC",
    descending: true
  };
  userSearch = "";
  records: UserAuditRecord[] = [];

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  get userCompanies(): Company[] {
    if (!this.$store.state.userCompanies) {
      return [];
    }
    return this.$store.state.userCompanies;
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  close() {
    this.dialog = false;
  }

  async refreshRecords() {
    this.isLoading = true;
    try {
      this.records = await domain.backend.userAuditQuery(this.filters);
    } catch (error) {
      util.logError("Error listando usuarios", error);
      this.records = [];
      this.snackShow(uiUtil.toErrorMsg(error, this.lang.errorUserList), "error");
    }
    this.isLoading = false;
    this.userSearch = "";
  }

  get tableHeaders() {
    const headers: { text: string; align: string; value: string }[] = [];
    headers.push({
      text: this.lang.uid,
      align: "left",
      value: "uid"
    });
    headers.push({
      text: this.lang.email2,
      align: "center",
      value: "email"
    });
    headers.push({
      text: this.lang.accessUtc,
      align: "center",
      value: "signInTimeUTC"
    });
    return headers;
  }

  // ------ PUBLIC Methods ------- //
  openForUser(uid: string) {
    this.filters = {
      uid,
      limit: 1000,
      from: "",
      to: ""
    };
    this.records = [];
    this.dialog = true;
    return this.refreshRecords();
  }
  openForQuery() {
    this.filters = {
      uid: "",
      limit: 2000,
      from: util.isoDateString(-5),
      to: util.isoDateString()
    };
    this.records = [];
    this.dialog = true;
    return this.refreshRecords();
  }
  // ------ PUBLIC Methods ------- //
}
